import PageHeader from "@/components/layout/PageHeader"

export default {
    install(Vue) {
        Vue.component("PageHeader", PageHeader)
    },
}
